import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/effect-fade";
import { EffectFade, Pagination, Autoplay } from 'swiper/modules';

export default function banner() {
    return (
        <>
            <Swiper
                spaceBetween={0}
                loop={true}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                modules={[EffectFade, Pagination, Autoplay]}
                effect={"fade"}
                className="main-banner"
            >
                <SwiperSlide>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6"></div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-5">
                                <div className='banner-div'>
                                    <div className="banner_text">
                                        <h1>Centerless Grinding<br />Machine</h1>
                                        <p>Expertise the design and development of RF equipment for wireless device testing</p>
                                        <Link className="btn btn-primary" to="">Read More</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className='banner-div'>
                                    <div className="banner_text">
                                        <h1>CNC Grinding<br />Machine</h1>
                                        <p>Characterise and Improve RF performance for 5G device with our RF Shield Boxes</p>
                                        <Link className="btn btn-primary" to="">Read More</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-6"></div>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </>
    );
}
